import {
  selectConnectionQualityByPeerID,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { Peer } from "@/react/types/Live/Peer";
import type { ProviderPeerSignal } from "../types";

export const useHMSPeerSignal = (
  peer: Pick<Peer, "id">,
): ProviderPeerSignal => {
  const peerDownlinkQuality = useHMSStore(
    selectConnectionQualityByPeerID(peer?.id),
  )?.downlinkQuality;

  return {
    peerDownlinkQuality,
  };
};
